// extracted by mini-css-extract-plugin
export default {"form":"Contact_form__AkJRS","input":"Contact_input__C51Bf","sendButton":"Contact_sendButton__TbO8J"};